import React, { useEffect, useRef, useState } from "react";
import { Grid, Header, Divider, Button, Modal, Form } from "semantic-ui-react";
import { reduxForm, Field, FieldArray, getFormValues } from "redux-form";
import { connect } from "react-redux";
import { useReactToPrint } from "react-to-print";
import { renderTextField, renderOptionFreeField } from "../formcomponents";
import PerformaItemFieldArr from "./PerformaItemFieldArr";
import PerformaInvoicePrintView, {
  PERFORMA_PRINT_PAGE_STYLE,
  suppressPerformaPrintChrome,
  EMPTY_BANK_DETAILS,
  parseBankDetails,
  hasBankDetails,
} from "./PerformaInvoicePrintView";
import axios from "axios";
import { BaseUrl, BaseUrlInvoice } from "../formcomponents/Constants";
import Swal from "sweetalert2";
import { useNavigate, useParams } from "react-router";
import { userData } from "../store/userData";

const NewPerformaInvoice = (props) => {
  const { handleSubmit, pristine, reset, submitting } = props;
  const navigate = useNavigate();
  const { id } = useParams();
  const [userDetail, setuserDetail] = useState(userData() || "");
  const [buttonDisable, setbuttonDisable] = useState(false);
  const [personOptions, setPersonOptions] = useState([]);
  const [workNameOptions, setWorkNameOptions] = useState([]);
  const [bankModalOpen, setBankModalOpen] = useState(false);
  const [viewBankDetails, setViewBankDetails] = useState({
    ...EMPTY_BANK_DETAILS,
  });
  const printRef = useRef();
  const isAdmin = userDetail && userDetail.userRole == 1;

  const formatDateToYYYYMMDD = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const getCurrentUserName = (user) => {
    if (!user) {
      return "";
    }
    return `${user.userFirstName || ""} ${user.userLastName || ""}`.trim();
  };

  const addPersonOption = (name) => {
    if (!name) {
      return;
    }
    setPersonOptions((prev) => {
      if (prev.some((option) => option.value === name)) {
        return prev;
      }
      return [{ key: name, text: name, value: name }, ...prev];
    });
  };

  useEffect(() => {
    const currentUser = userData();
    setuserDetail(currentUser);
    getPersonList();
    getWorkCatList();
    if (id !== "null") {
      getInvoiceDetails(id);
      if (currentUser.userRole != 1) {
        setbuttonDisable(true);
      }
    } else {
      const ownName = getCurrentUserName(currentUser);
      props.initialize({
        invoiceDate: formatDateToYYYYMMDD(new Date()),
        personUserId: currentUser.userId,
        personName: ownName,
        companyName: "",
        itemList: [{}],
      });
      addPersonOption(ownName);
    }
  }, [id]);

  const getPersonList = () => {
    axios
      .get(BaseUrl + "getBackOfficeUserList")
      .then((res) => {
        const options = (res.data || []).map((user) => {
          const name = `${user.userFirstName || ""} ${user.userLastName || ""}`.trim();
          return {
            key: user.userId,
            text: name,
            value: name,
            userId: user.userId,
          };
        });
        setPersonOptions((prev) => {
          const extra = prev.filter(
            (option) => !options.some((item) => item.value === option.value)
          );
          return [...extra, ...options];
        });
      })
      .catch((error) => console.log(error));
  };

  const addWorkNameOption = (name) => {
    if (!name) {
      return;
    }
    setWorkNameOptions((prev) => {
      if (prev.some((option) => option.value === name)) {
        return prev;
      }
      return [{ key: name, text: name, value: name }, ...prev];
    });
  };

  const getWorkCatList = async () => {
    await axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 90087,
      })
      .then((res) => {
        const resData = res.data || [];
        const tempList = [];
        for (let i = 0; i < resData.length; i++) {
          tempList.push({
            text: resData[i].categoryName,
            value: resData[i].categoryName,
            additionalInfo: resData[i].additionalInfo,
          });
        }
        setWorkNameOptions((prev) => {
          const extra = prev.filter(
            (option) => !tempList.some((item) => item.value === option.value)
          );
          return [...extra, ...tempList];
        });
      })
      .catch((error) => console.log(error));
  };

  const getInvoiceDetails = (invoiceId) => {
    axios
      .post(BaseUrlInvoice + "accounts/getPerformaInvoiceDetails", {
        ssPerformaInvoiceId: invoiceId,
      })
      .then((res) => {
        props.initialize({
          ssPerformaInvoiceId: res.data.ssPerformaInvoiceId,
          userId: res.data.userId,
          invoiceDate: res.data.invoiceDate,
          invoiceName: res.data.invoiceName,
          customerContact: res.data.customerContact,
          email: res.data.email,
          invoiceNumber: res.data.invoiceNumber,
          personUserId: res.data.personUserId,
          personName: res.data.personName,
          companyName: res.data.companyName || "",
          workName: res.data.workName,
          itemList:
            res.data.itemList && res.data.itemList.length > 0
              ? res.data.itemList
              : [{}],
        });
        addPersonOption(res.data.personName);
        addWorkNameOption(res.data.workName);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const parsePrice = (value) => {
    const amount = parseFloat(value);
    return isNaN(amount) ? 0 : amount;
  };

  const goBack = () => {
    navigate("/list-performa-invoice");
  };

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    documentTitle: " ",
    pageStyle: PERFORMA_PRINT_PAGE_STYLE,
    onBeforePrint: suppressPerformaPrintChrome,
  });

  const getPdfData = () => {
    const values = props.formValues || {};
    const additionalInfo = getSelectedWorkBankRaw();
    const companyName = values.companyName || values.invoiceName || "";
    const customerContact = values.customerContact || values.mobile || "";
    const email = values.email || values.emailId || "";
    return {
      date: values.invoiceDate,
      to: values.invoiceName,
      invoiceName: values.invoiceName,
      customerContact,
      mobile: customerContact,
      email,
      invoiceNumber: values.invoiceNumber,
      personName: values.personName || "",
      companyName,
      workName: values.workName,
      additionalInfo,
      bankDetails: parseBankDetails(additionalInfo),
      rowData: values.itemList || [],
    };
  };

  const getSelectedWorkBankRaw = () => {
    const workName = props.formValues?.workName;
    if (!workName) {
      return "";
    }
    const selected = workNameOptions.find(
      (option) => option.value === workName || option.text === workName
    );
    return selected?.additionalInfo || "";
  };

  const handleViewBankDetails = () => {
    const workName = props.formValues?.workName;
    const details = parseBankDetails(getSelectedWorkBankRaw());
    if (!workName || !hasBankDetails(details)) {
      Swal.fire({
        icon: "info",
        title: "No bank details",
        text: "No bank details exist for the selected work name.",
      });
      return;
    }
    setViewBankDetails(details);
    setBankModalOpen(true);
  };

  const handleGeneratePdf = () => {
    handlePrint();
  };

  const sumbitForm = (values) => {
    const typedName = (values.personName || "").trim();
    const matchedPerson = personOptions.find(
      (option) => option.value === typedName || option.text === typedName
    );
    const payload = {
      ...values,
      userId: userDetail.userId,
      invoiceDate: values.invoiceDate || formatDateToYYYYMMDD(new Date()),
      personName: isAdmin ? typedName : getCurrentUserName(userDetail),
      personUserId: isAdmin
        ? matchedPerson && matchedPerson.userId
          ? matchedPerson.userId
          : 0
        : userDetail.userId,
      itemList: (values.itemList || []).map((item) => ({
        ...item,
        allAttractions: item.allAttractions || "",
        nonPrimeAdult: parsePrice(item.nonPrimeAdult),
        nonPrimeChild: parsePrice(item.nonPrimeChild),
        primeTimeAdult: parsePrice(item.primeTimeAdult),
        primeTimeChild: parsePrice(item.primeTimeChild),
      })),
    };

    const apiUrl =
      id !== "null"
        ? BaseUrlInvoice + "accounts/editPerformaInvoice"
        : BaseUrlInvoice + "accounts/createPerformaInvoice";

    axios
      .post(apiUrl, payload)
      .then((res) => {
        if (res.data.errCode === 200) {
          Swal.fire(
            id !== "null"
              ? "All Attractions Updated"
              : "All Attractions Created"
          );
          navigate("/list-performa-invoice");
        } else {
          Swal.fire("Error", res.data.errMessage || "Failure", "error");
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire("Error", "Unable to save All Attractions", "error");
      });
  };

  return (
    <div>
      <Grid.Row>
        <Header dividing size="huge" as="h1">
          All Attractions
        </Header>
      </Grid.Row>
      <Divider hidden />
      <Grid.Row>
        <Button type="button" primary onClick={() => goBack()}>
          Go Back
        </Button>
        <Button type="button" color="purple" onClick={handleGeneratePdf}>
          Generate PDF
        </Button>
      </Grid.Row>
      <br />
      <style>
        {`
          .performa-work-name-field .ui.selection.dropdown {
            min-height: 2.714em;
            height: auto !important;
            white-space: normal;
            width: 100% !important;
          }
          .performa-work-name-field .ui.selection.dropdown > .text {
            white-space: normal !important;
            word-break: break-word;
            overflow-wrap: anywhere;
            overflow: visible !important;
            max-width: 100%;
          }
          .performa-work-name-row {
            display: flex;
            align-items: flex-end;
            gap: 8px;
            width: 100%;
          }
          .performa-work-name-dropdown {
            flex: 1 1 auto;
            min-width: 0;
          }
          .performa-work-name-bank-btn {
            flex: 0 0 auto;
            margin-bottom: 1em;
          }
        `}
      </style>
      <Grid>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Field
              name="invoiceDate"
              label="Date"
              type="date"
              disabled="true"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="invoiceName"
              label="Customer Name"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="companyName"
              label="Company Name"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Field
              name="customerContact"
              label="Mobile"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="email"
              label="Email"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
          <Grid.Column>
            <Field
              name="invoiceNumber"
              label="Invoice NO"
              type="text"
              component={renderTextField}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row columns={3}>
          <Grid.Column>
            <Field
              name="personName"
              label="Person Name"
              options={personOptions}
              disabled={!isAdmin}
              component={renderOptionFreeField}
            />
          </Grid.Column>
        </Grid.Row>
        <Grid.Row>
          <Grid.Column width={16} className="performa-work-name-field">
            <div className="performa-work-name-row">
              <div className="performa-work-name-dropdown">
                <Field
                  name="workName"
                  label="Work"
                  options={workNameOptions}
                  component={renderOptionFreeField}
                />
              </div>
              <div className="performa-work-name-bank-btn">
                <Button
                  type="button"
                  size="small"
                  compact
                  onClick={handleViewBankDetails}
                >
                  Bank Details
                </Button>
              </div>
            </div>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider hidden />
      <FieldArray name="itemList" component={PerformaItemFieldArr} />
      <Divider hidden />
      <Button
        type="submit"
        floated="right"
        positive
        disabled={buttonDisable}
        onClick={handleSubmit((values) => sumbitForm(values))}
      >
        Save
      </Button>
      <Button
        floated="right"
        negative
        disabled={pristine || submitting}
        onClick={reset}
      >
        Cancel
      </Button>
      <Modal
        open={bankModalOpen}
        onClose={() => setBankModalOpen(false)}
        size="small"
      >
        <Modal.Header>Bank Details</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths="equal">
              <Form.Input
                label="Account Holder Name"
                placeholder="Account Holder Name"
                value={viewBankDetails.accountHolderName}
                readOnly
              />
              <Form.Input
                label="Bank Name"
                placeholder="Bank Name"
                value={viewBankDetails.bankName}
                readOnly
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                label="Account Number"
                placeholder="Account Number"
                value={viewBankDetails.accountNumber}
                readOnly
              />
              <Form.Input
                label="IBAN"
                placeholder="IBAN"
                value={viewBankDetails.iban}
                readOnly
              />
            </Form.Group>
            <Form.Group widths="equal">
              <Form.Input
                label="SWIFT / BIC"
                placeholder="SWIFT / BIC"
                value={viewBankDetails.swiftBic}
                readOnly
              />
              <Form.Input
                label="Branch"
                placeholder="Branch"
                value={viewBankDetails.branch}
                readOnly
              />
            </Form.Group>
            <Form.Input
              label="Bank Address"
              placeholder="Bank Address"
              value={viewBankDetails.bankAddress}
              readOnly
            />
            <Form.Group widths="equal">
              <Form.Input
                label="Country"
                placeholder="Country"
                value={viewBankDetails.country}
                readOnly
              />
              <Form.Input
                label="Currency"
                placeholder="Currency"
                value={viewBankDetails.currency}
                readOnly
              />
            </Form.Group>
            <Form.Input
              label="Routing Number (optional)"
              placeholder="Routing Number"
              value={viewBankDetails.routingNumber}
              readOnly
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setBankModalOpen(false)}>Close</Button>
        </Modal.Actions>
      </Modal>
      <div
        style={{
          position: "absolute",
          left: "-10000px",
          top: 0,
        }}
      >
        <PerformaInvoicePrintView ref={printRef} dataObject={getPdfData()} />
      </div>
    </div>
  );
};

export default connect((state) => ({
  formValues: getFormValues("NewPerformaInvoice")(state),
}))(
  reduxForm({
    form: "NewPerformaInvoice",
  })(NewPerformaInvoice)
);
